import { createSlice } from "@reduxjs/toolkit";
import { getAllPoliciesThunk, getBenefitSummaryThunk, getHealthQualityThunk, getHealthResultThunk, getLifeResult, getPolicyDetailThunk, getQuestionsThunk, getSinglePolicy, postHealthQualityResultThunk, postQualityCheckThunk, putPolicyData, uploadPolicyThunk, checkCouponThunk, getMotorPreview, getMotorReviewData, submitReviewData, getMotorBenefitSummary, getMotorKypResult } from "store/thunk/kyp.thunk";

interface initialStateProps {
  loading: boolean;
  error: string | null;
  allPolicies: any;
  loadingPolicies: boolean;
  loadingBenefit: boolean;
  loadingHealthQuality: boolean;
  loadingHealthResult: boolean;
  loadingQuestions: boolean;
  loadingLifeQuality: boolean;
  loadingUploadPolicy: boolean;
  loadingPutPolicy: boolean;
  benefitSummary: any;
  healthQualityData: any;
  healthQualityResult: any;
  policyData: any;
  docList: any[];
  uploadedFileType: "pdf" | "image" | "";
  successKYPResult: any;
  doceyeOutputLoading: boolean;
  doceyeOutputData: any;
  questionsValue: any;
  lifeQualityData: any;
  loadingLifeResult: boolean;
  lifeResultData: any;
  healthQualityResultLoading: boolean;
  loadingCoupon: boolean;
  loadingMotorPreview: boolean;
  motorPreviewData: any;
  loadingMotorReview: boolean;
  motorReviewData: any;
  motorSubmitLoading: boolean;
  motorBenefitLoading: boolean;
  motorBenefitData: any;
  motorResultLoading: boolean;
  motorResultData: any;
}

const initialState: initialStateProps = {
  loading: false,
  error: null,
  allPolicies: [],
  loadingPolicies: false,
  loadingBenefit: false,
  loadingHealthQuality: false,
  loadingHealthResult: false,
  loadingQuestions: false,
  doceyeOutputLoading: false,
  loadingLifeQuality: false,
  loadingUploadPolicy: false,
  loadingPutPolicy: false,
  loadingLifeResult: false,
  healthQualityResultLoading: false,
  benefitSummary: "",
  healthQualityData: "",
  healthQualityResult: "",
  policyData: "",
  docList: [],
  uploadedFileType: "",
  successKYPResult: "",
  doceyeOutputData: "",
  questionsValue: "",
  lifeQualityData: "",
  lifeResultData: "",
  loadingCoupon: false,
  loadingMotorPreview: false,
  motorPreviewData: "",
  loadingMotorReview: false,
  motorReviewData: "",
  motorSubmitLoading: false,
  motorBenefitLoading: false,
  motorBenefitData: "",
  motorResultLoading: false,
  motorResultData: ""
};

const kypSlice = createSlice({
  name: "KYP Slice",
  initialState,
  reducers: {
    saveDocList: (state, action) => {
      state.docList = action.payload;
    },
    uploadedFileType: (state, action) => {
      state.uploadedFileType = action.payload;
    },
    successKYPResult: (state, action) => {
      state.successKYPResult = action.payload;
    },
    clearData: (state) => {
      state.docList = [];
      state.uploadedFileType = "";
      state.successKYPResult = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPoliciesThunk.pending, (state) => {
        state.loadingPolicies = true;
      })
      .addCase(getAllPoliciesThunk.fulfilled, (state, action) => {
        state.loadingPolicies = false;
        state.allPolicies = action.payload?.data;
        state.error = null;
      })
      .addCase(getAllPoliciesThunk.rejected, (state, action) => {
        state.loadingPolicies = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(getBenefitSummaryThunk.pending, (state) => {
        state.loadingBenefit = true;
      })
      .addCase(getBenefitSummaryThunk.fulfilled, (state, action) => {
        state.loadingBenefit = false;
        state.benefitSummary = action.payload?.data;
        state.error = null;
      })
      .addCase(getBenefitSummaryThunk.rejected, (state, action) => {
        state.loadingBenefit = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(getHealthQualityThunk.pending, (state) => {
        state.loadingHealthQuality = true;
      })
      .addCase(getHealthQualityThunk.fulfilled, (state, action) => {
        state.loadingHealthQuality = false;
        state.healthQualityData = action.payload?.data;
        state.error = null;
      })
      .addCase(getHealthQualityThunk.rejected, (state, action) => {
        state.loadingHealthQuality = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(getHealthResultThunk.pending, (state) => {
        state.loadingHealthResult = true;
      })
      .addCase(getHealthResultThunk.fulfilled, (state, action) => {
        state.loadingHealthResult = false;
        state.healthQualityResult = action.payload?.data;
        state.error = null;
      })
      .addCase(getHealthResultThunk.rejected, (state, action) => {
        state.loadingHealthResult = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(getSinglePolicy.pending, (state) => {
        state.loadingHealthQuality = true;
      })
      .addCase(getSinglePolicy.fulfilled, (state, action) => {
        state.loadingHealthQuality = false;
        state.policyData = action.payload?.data;
        state.error = null;
      })
      .addCase(getSinglePolicy.rejected, (state, action) => {
        state.loadingHealthQuality = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(getPolicyDetailThunk.pending, (state) => {
        state.doceyeOutputLoading = true;
      })
      .addCase(getPolicyDetailThunk.fulfilled, (state, action) => {
        state.doceyeOutputLoading = false;
        state.doceyeOutputData = action.payload?.data;
        state.error = null;
      })
      .addCase(getPolicyDetailThunk.rejected, (state, action) => {
        state.doceyeOutputLoading = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(getQuestionsThunk.pending, (state) => {
        state.loadingQuestions = true;
      })
      .addCase(getQuestionsThunk.fulfilled, (state, action) => {
        state.loadingQuestions = false;
        state.questionsValue = action.payload?.data;
        state.error = null;
      })
      .addCase(getQuestionsThunk.rejected, (state, action) => {
        state.loadingQuestions = false;
        state.error = action.error.message ?? "An error occurred";
      })
      .addCase(postQualityCheckThunk.pending, (state) => {
        state.loadingLifeQuality = true;
      })
      .addCase(postQualityCheckThunk.fulfilled, (state, action) => {
        state.loadingLifeQuality = false;
        state.lifeQualityData = action.payload?.data;
        state.error = null;
      })
      .addCase(postQualityCheckThunk.rejected, (state, action) => {
        state.loadingLifeQuality = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(uploadPolicyThunk.pending, (state) => {
        state.loadingUploadPolicy = true;
      })
      .addCase(uploadPolicyThunk.fulfilled, (state) => {
        state.loadingUploadPolicy = false;
        state.error = null;
      })
      .addCase(uploadPolicyThunk.rejected, (state, action) => {
        state.loadingUploadPolicy = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(putPolicyData.pending, (state) => {
        state.loadingPutPolicy = true;
      })
      .addCase(putPolicyData.fulfilled, (state) => {
        state.loadingPutPolicy = false;
        state.error = null;
      })
      .addCase(putPolicyData.rejected, (state, action) => {
        state.loadingPutPolicy = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(getLifeResult.pending, (state) => {
        state.loadingLifeResult = true;
      })
      .addCase(getLifeResult.fulfilled, (state, action) => {
        state.loadingLifeResult = false;
        state.lifeResultData = action.payload?.data;
        state.error = null;
      })
      .addCase(getLifeResult.rejected, (state, action) => {
        state.loadingLifeResult = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(postHealthQualityResultThunk.pending, (state) => {
        state.healthQualityResultLoading = true;
      })
      .addCase(postHealthQualityResultThunk.fulfilled, (state) => {
        state.healthQualityResultLoading = false;
        state.error = null;
      })
      .addCase(postHealthQualityResultThunk.rejected, (state, action) => {
        state.healthQualityResultLoading = false;
        state.error = action.error.message ?? "An error occurred";
      })
      .addCase(checkCouponThunk.pending, (state) => {
        state.loadingCoupon = true;
      })
      .addCase(checkCouponThunk.fulfilled, (state) => {
        state.loadingCoupon = false;
        state.error = null;
      })
      .addCase(checkCouponThunk.rejected, (state, action) => {
        state.loadingCoupon = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(getMotorPreview.pending, (state) => {
        state.loadingMotorPreview = true;
      })
      .addCase(getMotorPreview.fulfilled, (state, action) => {
        state.loadingMotorPreview = false;
        state.motorPreviewData = action.payload?.data;
        state.error = null;
      })
      .addCase(getMotorPreview.rejected, (state, action) => {
        state.loadingMotorPreview = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(getMotorReviewData.pending, (state) => {
        state.loadingMotorReview = true;
      })
      .addCase(getMotorReviewData.fulfilled, (state, action) => {
        state.loadingMotorReview = false;
        state.motorReviewData = action.payload?.data;
        state.error = null;
      })
      .addCase(getMotorReviewData.rejected, (state, action) => {
        state.loadingMotorReview = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(submitReviewData.pending, (state) => {
        state.motorSubmitLoading = true;
      })
      .addCase(submitReviewData.fulfilled, (state) => {
        state.motorSubmitLoading = false;
        state.error = null;
      })
      .addCase(submitReviewData.rejected, (state, action) => {
        state.motorSubmitLoading = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(getMotorBenefitSummary.pending, (state) => {
        state.motorBenefitLoading = true;
      })
      .addCase(getMotorBenefitSummary.fulfilled, (state, action) => {
        state.motorBenefitLoading = false;
        state.motorBenefitData = action.payload?.data;
        state.error = null;
      })
      .addCase(getMotorBenefitSummary.rejected, (state, action) => {
        state.motorBenefitLoading = false;
        state.error = action.error.message ?? "An error occurred";
      })

      .addCase(getMotorKypResult.pending, (state) => {
        state.motorResultLoading = true;
      })
      .addCase(getMotorKypResult.fulfilled, (state, action) => {
        state.motorResultLoading = false;
        state.motorResultData = action.payload?.data;
        state.error = null;
      })
      .addCase(getMotorKypResult.rejected, (state, action) => {
        state.motorResultLoading = false;
        state.error = action.error.message ?? "An error occurred";
      });
  }
});

export const { saveDocList, uploadedFileType, successKYPResult, clearData } = kypSlice.actions;

export default kypSlice.reducer;
